import type { AccountInfo } from '@azure/msal-browser';
import { ROLE_CLAIMS, type Persona } from '@/types/auth.types';

export function determinePersona(account: AccountInfo | null): Persona {
  if (!account?.idTokenClaims) {
    return 'Employee';
  }

  const roles = getRolesFromClaims(account.idTokenClaims);

  if (roles.includes(ROLE_CLAIMS.ADMIN)) {
    return 'Admin';
  }

  if (roles.includes(ROLE_CLAIMS.PLANNER)) {
    return 'Planner';
  }

  return 'Employee';
}

export function getRolesFromClaims(claims: Record<string, unknown>): readonly string[] {
  const roles = claims['roles'];

  if (Array.isArray(roles)) {
    return roles.filter((role): role is string => typeof role === 'string');
  }

  return [];
}

export function hasPersonaRole(roles: readonly string[], persona: Persona): boolean {
  switch (persona) {
    case 'Admin':
      return roles.includes(ROLE_CLAIMS.ADMIN);
    case 'Planner':
      return roles.includes(ROLE_CLAIMS.PLANNER);
    case 'Employee':
      return true;
  }
}

export function hasRequiredPersona(
  userPersona: Persona,
  requiredPersonas: readonly Persona[]
): boolean {
  return requiredPersonas.includes(userPersona);
}
